import dispatcher from "./../Dispatcher/Dispatcher";
import { EventEmitter } from "events";
import equipmentConstants from "./../Constants/EquipmentConstants";

let result = null;
let equipmentForm = [];
let scrapEquipmentResult = null;
let equipmentScrapImagesRes = null;

class EquipmentStore extends EventEmitter {
  getResult() {
    return result;
  }
  setResult(res) {
    result = res;
  }

  getScrapEquipmentResult() {
    return scrapEquipmentResult;
  }
  setScrapEquipmentResult(res) {
    scrapEquipmentResult = res;
  }

  getEquipmentForm() {
    return equipmentForm;
  }

  setEquipmentForm(res) {
    equipmentForm = res;
  }

  getEquipmentScrapImagesRes() {
    return equipmentScrapImagesRes;
  }

  setEquipmentScrapImagesRes(res) {
    equipmentScrapImagesRes = res;
  }

  emitChange(eventName) {
    this.emit(eventName);
  }

  addChangeListener(eventName, callback) {
    this.on(eventName, callback);
  }

  removeChangeListener(eventName, callback) {
    this.removeListener(eventName, callback);
  }

  handleCallback(action) {
    switch (action.type) {
      case equipmentConstants.DELETE_EQUIPMENT_SUCCESS:
        this.setResult(true);
        break;
      case equipmentConstants.DELETE_EQUIPMENT_FAILURE:
        this.setResult(false);
        break;
      case equipmentConstants.COPY_EQUIPMENT_SUCCESS:
        this.setResult(action.result);

        break;
      case equipmentConstants.COPY_EQUIPMENT_FAILURE:
        this.setResult(false);
        break;
      case equipmentConstants.GET_EQUIPMENTFORM_SUCCESS:
        this.setEquipmentForm(action.result);
        break;
      case equipmentConstants.GET_EQUIPMENTFORM_FAILURE:
        this.setEquipmentForm(action.result);
        break;
      case equipmentConstants.INSERT_NEWEQUIPMENT_SUCCESS:
        this.setResult(true);
        break;
      case equipmentConstants.INSERT_NEWEQUIPMENT_FAILURE:
        this.setResult(action.result);
        break;
      case equipmentConstants.UPDATE_EQUIPMENTSTATUS_SUCCESS:
        //this.setResult(true);
        break;
      case equipmentConstants.UPDATE_EQUIPMENTSTATUS_FAILURE:
        //this.setResult(null);
        break;
      case equipmentConstants.UPDATE_EQUIPMENT_SUCCESS:
        this.setResult(true);
        break;
      case equipmentConstants.UPDATE_EQUIPMENT_FAILURE:
        this.setResult(action.result);
        break;
      case equipmentConstants.SAVE_EQUIPMENT_IMAGES_SUCCESS:
        this.setResult(action.result);
        break;
      case equipmentConstants.SAVE_EQUIPMENT_IMAGES_FAILURE:
        this.setResult(action.result);
        break;
      case equipmentConstants.SET_EQUIPMENT_DEFAULT_IMAGE_SUCCESS:
        this.setResult(action.result);
        break;
      case equipmentConstants.SET_EQUIPMENT_DEFAULT_IMAGE_FAILURE:
        this.setResult(action.result);
        break;
      case equipmentConstants.SCRAP_EQUIPMENT_SUCCESS:
        this.setScrapEquipmentResult(action.result);
        break;
      case equipmentConstants.SCRAP_EQUIPMENT_FAILURE:
        this.setScrapEquipmentResult(action.result);
        break;
      case equipmentConstants.GET_EQUIPMENT_SCRAP_IMAGES_SUCCESS:
        this.setEquipmentScrapImagesRes(action.result);
        break;
      case equipmentConstants.GET_EQUIPMENT_SCRAP_IMAGES_FAILURE:
        this.setEquipmentScrapImagesRes(action.result);
        break;
      default:
        break;
    }
    this.emitChange(action.type);
    return true;
  }
}

const equipmentStore = new EquipmentStore();
dispatcher.register(equipmentStore.handleCallback.bind(equipmentStore));
export default equipmentStore;
